module.exports = __webpack_public_path__ + "static/media/gallery-close.8eb56189.png";